export default {
  name: "mBtnIndex",
  props: {
    text: null,
    src: null,
    noStyle: {
      default: false
    },
    background: {
      default: "#060820"
    },
    borderRadius: {
      default: "#44573c"
    },
    arcBackground: {
      default: "#bad80e"
    },
    fontSize: {
      default: 46
    }
  },
  computed: {},
  data() {
    return {};
  },
  methods: {
    confirmFn() {
      this.$emit("skip");
    }
  },
  mounted() {}
};